var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navbar-menu-item',_vm._g({attrs:{"icon":"search","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openSearch()}}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }